<div *ngIf="!props.hidden"
  class="input-group">
  <ng-container #fieldComponent></ng-container>
</div>